import Component from 'flarum/common/Component';
export default class SlideTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.tabList = this.attrs.tabList;
    this.showTabLine = this.attrs.showTabLine;
    this.selectedIndex = -1;
    this.style = this.attrs.style;
    this.id = this.attrs.id || "SlideTabID" + Math.round(Math.random() * 10000);
    this.component = this.attrs.component || function () {};
    this.offsetX = this.attrs.offsetX || 0;
    this.touchstartX = 0;
    this.touchendX = 0;
    if (this.showTabLine === undefined) {
      this.showTabLine = true;
    }
  }
  handleGesture() {
    let triggered = false;
    if (this.touchendX < this.touchstartX) {
      if (this.tabList.length > this.selectedIndex) {
        this.selectedIndex++;
        triggered = true;
      }
    }
    if (this.touchendX > this.touchstartX) {
      if (this.selectedIndex > 1) {
        this.selectedIndex--;
        triggered = true;
      }
    }
    if (triggered) {
      $("#zivenSlideTab-item-" + this.id + this.selectedIndex).click();
    }
  }
  oncreate() {
    this.checkHashTag();
    const _this = this;

    /*
    const isMobile = window.zivenCore.isMobile();
     if(isMobile){
      const gestureElement = document.getElementById("TabContainer"); // Or any other selector
       gestureElement.addEventListener('touchstart', e => {
          _this.touchstartX = e.changedTouches[0].screenX;
      });
       gestureElement.addEventListener('touchend', e => {
          _this.touchendX = e.changedTouches[0].screenX;
          _this.handleGesture();
          _this.touchstartX = 0;
          _this.touchendX = 0;
      });
    }
    */
  }
  checkHashTag() {
    const dom = $("#" + this.id);
    if (dom.length === 0) {
      return;
    }
    let urlHash = window.location.hash.substring(1);
    let tagChanged = false;
    for (let i = 0; i < this.tabList.length; i++) {
      if (this.tabList[i].key === urlHash) {
        const index = i + 1;
        if (this.selectedIndex != index) {
          this.selectedIndex = index;
          tagChanged = true;
        }
        break;
      }
    }
    if (this.selectedIndex === -1) {
      this.selectedIndex = 1;
      tagChanged = true;
    }
    if (tagChanged) {
      const screenWidth = screen.width;
      const containerWidth = $("#zivenSlideTabMenuContainer" + this.id).width();
      $("#zivenSlideTabLine" + this.id).width(containerWidth > screenWidth ? containerWidth : "100%");
      // 保留 click() 触发 tabEvent, 让父组件 selectedTab 跟着 URL 同步 (Mavis brief: 先 click 后 scroll, selectedTab 同步在前)
      $("#zivenSlideTab-item-" + this.id + this.selectedIndex).click();

      // 2026-09-28: 刷新页面 hash 还原后, 等 mithril 重渲染完 (label outerWidth 可测) 再水平滚动定位
      const targetIndex = this.selectedIndex;
      setTimeout(() => {
        this._scrollToSelected(targetIndex);
      }, 0);
    }
    $("#zivenSlideTabBar" + this.id).css('width', $("#zivenSlideTabBar" + this.id).css('width', $("#zivenSlideTab-item-" + this.id + this.selectedIndex).parent().find("span").outerWidth()));
  }
  selectItem(e, tabKey, tabEvent) {
    var _app$current;
    // 2026-07-31 1.8 mithril Stream .get() → 2.0 PageState .data.routeName
    const routeName = String(((_app$current = app.current) == null || (_app$current = _app$current.data) == null ? void 0 : _app$current.routeName) || '');
    const target = e.target;
    const elemCount = parseInt($(target).attr("count"));
    this._scrollToSelected(elemCount);
    tabEvent(e, tabKey);
    window.location.hash = tabKey;
    history.replaceState(undefined, undefined, "#" + tabKey);
  }

  // 2026-09-28: 抽出水平滚动定位逻辑, 供 selectItem (点击) 与 checkHashTag (刷新还原) 共用
  _scrollToSelected(index) {
    const target = $("#zivenSlideTab-item-" + this.id + index);
    const label = target.parent().find("span");
    let marginLeft = parseInt(this.offsetX);
    for (let i = 1; i < index; i++) {
      marginLeft += $("#zivenSlideTab-item-" + this.id + i).parent().find("span").outerWidth();
    }
    $("#" + this.id).animate({
      scrollLeft: marginLeft - window.screen.width / 2 + label.parent().width() / 2
    }, 350);
    $("#zivenSlideTabBar" + this.id).css('marginLeft', marginLeft);
    $("#zivenSlideTabBar" + this.id).css('width', label.outerWidth());
  }
  view() {
    this.checkHashTag();
    return m("div", {
      id: this.id,
      style: this.style,
      className: "zivenSlideTabMenu"
    }, this.component(), m("div", {
      id: "zivenSlideTabMenuContainer" + this.id,
      style: "margin-left: " + this.offsetX + "px;",
      className: "zivenSlideTabMenuContainer"
    }, this.tabList.map((tabData, index) => {
      const tabName = app.translator.trans(tabData.name);
      const tabEvent = tabData.event;
      const tabKey = tabData.key;
      const selectedIndex = index + 1;
      let tabWidth = tabData.width || "";
      let tempTab = document.createElement("DIV");
      tempTab.style.fontSize = "20px";
      tempTab.style.fontWeight = "bold";
      tempTab.style.padding = "10px";
      tempTab.style.width = "fit-content";
      tempTab.innerHTML = tabName;
      document.body.appendChild(tempTab);
      tabWidth = $(tempTab).outerWidth();
      document.body.removeChild(tempTab);
      return m("div", null, m("input", {
        type: "radio",
        count: selectedIndex,
        name: "zivenSlideTabItem" + this.id,
        id: "zivenSlideTab-item-" + this.id + selectedIndex,
        className: "zivenSlideTabToggle",
        onclick: e => {
          this.selectItem(e, tabKey, tabEvent);
          this.selectedIndex = selectedIndex;
        }
      }), m("label", {
        style: "width:" + (tabWidth === "" ? "max-content" : tabWidth + "px"),
        for: "zivenSlideTab-item-" + this.id + selectedIndex
      }, m("span", null, tabName)));
    })), m("div", {
      className: "zivenSlideTabClear"
    }), m("div", {
      className: "zivenSlideTab"
    }, this.showTabLine === true && m("div", {
      id: "zivenSlideTabLine" + this.id,
      className: "zivenSlideTabLine"
    }), m("div", {
      id: "zivenSlideTabBar" + this.id,
      className: "zivenSlideTabBar"
    })));
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/components/SlideTab', SlideTab);